import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./styles.module.css";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function GmailIntegrationPage() {
    const navigateTo = useNavigate();

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <div>
                    <h3>Integrations</h3>
                    <h5>Manage your account integrations.</h5>
                </div>
            </div>
            <div className={Classes.hero} >
                <div className={Classes.menuButtons} >
                    <button onClick={() => navigateTo("/integrations")} className={Classes.backButton}>
                        <LeftArrow height='12px' fill='#969696' />
                        <h5>Integrations</h5>
                    </button>
                    <h3>Integrations</h3>
                </div>
                <div className={Classes.grid} >
                    <div className={Classes.gridLeft}>
                        <ul className={Classes.sidebar} >

                        </ul>
                    </div>
                    <div className={Classes.gridRight} >
                        <div className={Classes.list} >
                            <div className={Classes.listLeft} >
                                <img src={'/assets/images/gmail.png'} />
                                <div>
                                    <h5 className={Classes.normalText} > Gmail </h5>
                                    <h5 className={Classes.lightText} >
                                        To start integrating your workspace with Gmail, click the button below to securely connect your account. 
                                        This is the recommended option for seamless email management and communication.
                                    </h5>
                                </div>
                            </div>
                            <div className={Classes.listRight} >
                                <button className={`${Classes.activateBtn} ${Classes.importButton}`} > <h5 >Import data </h5> </button>
                                <button className={`${Classes.activateBtn} ${Classes.deleteButton}`} > <h5 >Disable </h5> </button>
                            </div>
                        </div>
                        <button className={`${Classes.activateBtn} ${Classes.importBigButton}`} > <h5 > Connect with Gmail </h5> </button>
                    </div>
                </div>
            </div>
        </div>
    );
}